/**
 * <Main />
 *
 *
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 * @redux
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';
import { fetchUserByToken, } from './ducks/user';
import { getSubscription } from './ducks/subscription';
import LoginPage from 'containers/pages/Login';
import MobileScreen from './MobileScreen';
import MainContainer from './MainContainer';
import refreshToken from 'controllers/user/refreshToken'
import isEmpty from 'lodash/isEmpty'
import './Main.scss';

const mapStateToProps = state => ({
  user: state.user,
  subscription: state.gSubscription
});

const mapDispatchToProps = dispatch => {
  return {
    fetchUserByToken: () => dispatch(fetchUserByToken()),
    getSubscription: () => dispatch(getSubscription())
  };
};

class Main extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentWillMount() {
    this.props.fetchUserByToken();
    this.props.getSubscription();
  }

  componentWillReceiveProps(nextProps){
    if(!this.props.user.login && nextProps.user.login) {
      setInterval(function () {
        refreshToken({token: localStorage.getItem('token')})
          .then((result)=>{
            localStorage.setItem('token', result.data.token);
          });
      }, 3600000)
    }
  }

  render() {
    const {
      user,
      subscription,
      routes,
    } = this.props;
    const {result} = subscription;
    const {
      login,
      loginRequired
    } = user;

    return (

      <div className={classnames('Main')}>
        { login && (!isEmpty(result) && (result.maximum_amount.maximum_school !== 0 || (user.result.school_amount- user.result.school_owned_amount>0) || user.result.teacher_to_be_confirmed.length>0)) &&
          <MainContainer routes={routes}>{this.props.children}</MainContainer>
        }
        { (loginRequired || (!isEmpty(result) && result.maximum_amount.maximum_school === 0 && (user.result.school_amount- user.result.school_owned_amount) === 0) && user.result.teacher_to_be_confirmed.length === 0) &&
          <div className='LoginPageWrapper'>
            <LoginPage />
          </div>
        }
        <MobileScreen />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);



// WEBPACK FOOTER //
// ./src/containers/Main/index.js